/* ==================================================
  商品一覧・検索結果 モバイルツールバー追従（Boost SD）
  スクロールでツールバーを画面上部（可視ヘッダーの下）に固定する。
  main-collection / main-search の両セクションから読み込む。
  JS は is-fixed クラスの付与/削除と固定位置オフセットの算出のみを担当し、
  実際の固定は c_theme.css の position: fixed が担当（責務分離）。
  Boost SD は絞り込み・並び替えで DOM を非同期に作り直すため、
  MutationObserver で対象要素を取得し直し、元の位置を測り直す。
===================================================*/

document.addEventListener('DOMContentLoaded', () => {
  const SELECTOR = '.boost-sd__toolbar'; /* 固定する要素（件数行を除いた絞り込み/並び替え/表示バー） */
  const rootStyle = document.documentElement.style;
  const header = document.querySelector('store-header');

  const getTarget = () => document.querySelector(SELECTOR);
  let bar = getTarget();
  let barTop = bar ? bar.getBoundingClientRect().top + window.scrollY : null; /* 通常フロー時の絶対位置 */

  /* 可視ヘッダーの下端。sticky で top:0 に留まるため rect.bottom がそのまま見えている高さ。
     スクロールでコンパクト化して高さが変わるので都度実測する。 */
  const getHeaderOffset = () => (header ? Math.max(0, header.getBoundingClientRect().bottom) : 0);

  let ticking = false;
  const update = () => {
    ticking = false;
    if (!bar) return;

    const offset = getHeaderOffset();
    rootStyle.setProperty('--c-boost-toolbar-offset', offset + 'px');

    /* 固定中は rect が固定位置を返すため、元の位置(barTop)は非固定時のみ測り直す */
    if (!bar.classList.contains('is-fixed')) {
      barTop = bar.getBoundingClientRect().top + window.scrollY;
    }

    /* ツールバーの元位置がヘッダー下端より上に来たら固定 */
    bar.classList.toggle('is-fixed', window.scrollY > barTop - offset);
  };

  const onScroll = () => {
    if (!ticking) {
      ticking = true;
      requestAnimationFrame(update);
    }
  };

  /* Boost SD の再描画で対象要素が差し替わるため取得し直し、元位置を測り直す */
  const observer = new MutationObserver(() => {
    const next = getTarget();
    if (next && next !== bar) {
      bar = next;
      barTop = bar.getBoundingClientRect().top + window.scrollY; /* 再挿入直後は通常フロー */
    }
    onScroll();
  });
  observer.observe(document.body, { childList: true, subtree: true });

  window.addEventListener('scroll', onScroll, { passive: true });
  window.addEventListener('resize', onScroll, { passive: true });
  if (header) header.addEventListener('transitionend', onScroll); /* ヘッダー開閉アニメ終了後に測り直す */
  if (document.fonts) document.fonts.ready.then(onScroll);

  update();
});
